<template>
    <div id="location">
        <section class="section">
            <div class="container">
                <h2 class="section-title" v-scroll-reveal>
                    <span class="_order">05</span>
                    <span class="_title" v-html="$t('Location')"></span>
                </h2>

                <div class="flex flex-wrap -mx-2 -mb-base">
                    <div class="w-1/2 md:w-1/4 px-2 mb-base">
                        <div class="flex flex-col text-center">
                            <span class="text-gray-light text-h5 uppercase" v-html="$t('Beach')"></span>
                            <span class="text-secondary text-display text-h2 md:text-h1 md:my-base" v-scroll-reveal>11 km</span>
                            <span class="text-secondary text-display text-h5">Kanegra</span>
                        </div>
                    </div>

                    <div class="w-1/2 md:w-1/4 px-2 mb-base">
                        <div class="flex flex-col text-center">
                            <span class="text-gray-light text-h5 uppercase" v-html="$t('Airport')"></span>
                            <span class="text-secondary text-display text-h2 md:text-h1 md:my-base" v-scroll-reveal>82 km</span>
                            <span class="text-secondary text-display text-h5">Pula</span>
                        </div>
                    </div>
            
                    <div class="w-1/2 md:w-1/4 px-2 mb-base">
                        <div class="flex flex-col text-center">
                            <span class="text-gray-light text-h5 uppercase" v-html="$t('Restaurant')"></span>
                            <span class="text-secondary text-display text-h2 md:text-h1 md:my-base" v-scroll-reveal>800 m</span>
                            <span class="text-secondary text-display text-h5">Momjan</span>
                        </div>
                    </div>
            
                    <div class="w-1/2 md:w-1/4 px-2 mb-base">
                        <div class="flex flex-col text-center">
                            <span class="text-gray-light text-h5 uppercase" v-html="$t('Shop')"></span>
                            <span class="text-secondary text-display text-h2 md:text-h1 md:my-base" v-scroll-reveal>800 m</span>
                            <span class="text-secondary text-display text-h5">Momjan</span>
                        </div>
                    </div>
                </div>

            </div> 
        </section>

        <section class="section section-cover">
            <figure style="background-image: url(/img/Momjan-1.jpg)"></figure>
        </section>

        <section class="section">
            <div class="container container-wide mb-gap md:mb-gap-lg fhd:mb-gap-xl">
                <div class="flex flex-wrap xl:flex-row-reverse xl:items-center -mx-2">
                    <div class="w-full xl:w-3/5 px-2">
                        <figure class="floating-img _right shadow-lg" v-scroll-reveal style="background-image: url(/img/Kanegra.jpg)"></figure>
                    </div>

                    <div class="w-full xl:w-2/5 px-2 xl:pr-gap-lg fhd:mb-gap-lg" v-scroll-reveal v-html="$t('index.location.text')"></div>
                </div>
            </div>

            <div class="container">
                <div class="flex flex-wrap items-center">
                    <div class="w-full md:w-1/3 mb-base md:mb-0">
                        <h3 class="section-subtitle" v-scroll-reveal v-html="$t('index.location.title')"></h3>
                    </div>

                    <div class="w-full md:w-1/2 md:ml-auto" v-scroll-reveal v-html="$t('index.location.text-2')"></div>
                </div>
            </div>
        </section>

        <section class="section section-cover" v-scroll-reveal>
            <figure id="map" class="map-wrapper"></figure>
        </section>

        <section class="section">
            <div class="container" v-scroll-reveal v-html="$t('index.location.text-3')"></div>
        </section>
    </div>
</template>

<script>
export default {}
</script>
